import { render, staticRenderFns } from "./ModalEditProfile.vue?vue&type=template&id=25b9a5dc&"
import script from "./ModalEditProfile.vue?vue&type=script&lang=js&"
export * from "./ModalEditProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {FormInput: require('/workspace/components/Form/FormInput.vue').default,FormSelect: require('/workspace/components/Form/FormSelect.vue').default,FormDatePicker: require('/workspace/components/Form/FormDatePicker.vue').default})
